import * as z from "zod/v4";

export const sendSlackAIMessage = {
  name: "sendSlackAIMessage" as const,
  input: z.object({
    channelId: z.string(),
    teamId: z.string(),
    messageTs: z.string(),
    threadTs: z.string().optional(),
    messageText: z.string(),
    triageThreadId: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
